import {Style, Fill, Stroke, Text} from 'ol/style.js';
import {transformExtent} from 'ol/proj';
import {GeoJsonLayer} from '../GeoJsonLayer.js';
import Library from '../Library.js';

export class GairmetLayer extends GeoJsonLayer {

    types = ["turbhi", "turblo", "llws", "sfcwind", "icing", "frzlvl", "ifr", "mtnobs" ];

    constructor( map, settings = {} ){
        settings["name"] = 'gairmet';
        settings["dynamic_time"] = true;
        settings["dynamic_level"] = true;
        settings["api_endpt"] = "GairmetJSON.php";
        if( settings.opacity == undefined ) settings['opacity'] = .25;
        if( settings.hazards == undefined ) settings['hazards'] = "all";
        super( map, settings );
        // Setup checkbox on UI
        this,this.setHazards(this.settings['hazards'], false);
    }

    getUrl( extent, resolution, projection ){
        let extent1 = transformExtent(extent, projection, "EPSG:4326");
        let url = new URL( this.api_path + "/" + this.api_endpt );
        url.searchParams.set( "bbox", extent1.join(","));
        url.searchParams.set( "zoom", this.map.view.getZoom());
        url.searchParams.set( "hazard", this.settings['hazards']);
        if( this.map.level != undefined ) url.searchParams.set( "level", this.map.level );
        url.searchParams.set( "date", Library.formatDate( "ymd_hn", this.map.secs ));
        return url.toString();
    }

    getColor( feature ){
        if( this.property(feature,'hazard') == "TURB-HI" )
            return "#FF6600";
        if( this.property(feature,'hazard') == "TURB-LO" )
            return "#CC3300";
        if( this.property(feature,'hazard') == "LLWS" )
            return "#993333";
        if( this.property(feature,'hazard') == "SFC_WND" )
            return "#CC6600";
        if( this.property(feature,'hazard') == "IFR" )
            return "#990099";
        if( this.property(feature,'hazard') == "MT_OBSC" )
            return "#FF00FF";
        if( this.property(feature,'hazard') == "ICE" )
            return "#0000FF";
        if( this.property(feature,'hazard') == "FZLVL" )
            return "#6666FF";
        if( this.property(feature,'hazard') == "M_FZLVL" )
            return "#6666FF";
        return "#800000";
    }

    getLabel( feature ){
        let label = "";
        if( this.property(feature,'hazard') == "TURB-HI" )
            return "TurbHi";
        if( this.property(feature,'hazard') == "TURB-LO" )
            return "TurbLo";
        if( this.property(feature,'hazard') == "LLWS" )
            return "LLWS";
        if( this.property(feature,'hazard') == "SFC_WND" )
            return "SfcWind";
        if( this.property(feature,'hazard') == "IFR" )
            return "IFR";
        if( this.property(feature,'hazard') == "MT_OBSC" )
            return "MtnOb";
        if( this.property(feature,'hazard') == "ICE" )
            return "Icing";
        if( this.property(feature,'hazard') == "FZLVL" )
            return this.property(feature,'level');
        if( this.property(feature,'hazard') == "M_FZLVL" )
            return this.property(feature,'base')+"-"+this.property(feature,'top');
        return "UNK";
    }

    getOpacity(feature){
        return this.settings['opacity'];
    }

    getStyle(feature, resolution ){
        let style = new Style({
                "fill": new Fill({
                        "color": Library.parseHexColorToArray(this.getColor(feature), this.settings['opacity'])
                        }),
                "stroke": new Stroke({
                        "color": Library.parseHexColorToArray(this.getColor(feature)),
                        "width": 2
                        }),
                "text": new Text({
                        "font": "12px",
                        "fill": new Fill({
                                "color": Library.parseHexColorToArray("#800000")
                                }),
                        "text": this.getLabel(feature),
                        "stroke": new Stroke({"color": "white", "width": 2 })
                        })

                });
        return style;
    }

    getPopupText( feature ){
        let text = this.popupTitle( 'G-AIRMET', this.property(feature,'hazard'));
        text += this.popupData( "Valid", this.property(feature,'valid_time'));
        text += this.popupData( "Issued", this.property(feature,'issue_time'));
        if( this.property(feature,'severity') != undefined )
            text += this.popupData( "Severity", this.property(feature,'severity'));
        if( this.property(feature,'top') != undefined )
            text += this.popupData( "Top", this.property(feature,'top') + " ft" );
        if( this.property(feature,'base') != undefined ){
            if( this.property(feature,'base') == "FZL" )
                text += this.popupData( "Base", "Freezing level " + 
                        this.property(feature,'fzltop') + "/" + 
                        this.property(feature,'fzlbase'));
            else if( this.property(feature,'base') == "SFC" )
                text += this.popupData( "Base", "Surface" );
            else
                text += this.popupData( "Base", this.property(feature,'base') + " ft" );
        }
        if( this.property(feature,'level') != undefined ){
            if( this.property(feature,'level') == "SFC" )
                text += this.popupData( "Level", "stationary" );
            else
                text += this.popupData( "Level", this.property(feature,'level') + "00 ft" );
        }
        if( this.property(feature,'due_to') != undefined )
            text += this.popupData( "Due To", this.property(feature,'due_to') );
        text += this.popupEnd();
        return text;
    }

    setHazards(val, refresh = true){
        console.info( 'gairmet set hazard');
        if( val == undefined ){
            let params = [];
            for( let i = 0; i < this.types.length; i++ ){
                if( Library.getCheckbox( "check_gairmet_hazards_"+this.types[i] )){
                    params.push( this.types[i]);
                }
            }
            this.settings['hazards'] = params.join(",");
        } else {
            let params = val.split(",");
            if( params[0] == "all" ){
                for( let i = 0; i < this.types.length; i++ )
                    Library.setCheckbox( "check_gairmet_hazards_"+this.types[i], true );
            } else {
                for( let i = 0; i < this.types.length; i++ )
                    Library.setCheckbox( "check_gairmet_hazards_"+this.types[i], false );
            }
            for( let i = 0; i < params.length; i++ )
                Library.setCheckbox( "check_gairmet_hazards_"+params[i], true );

            this.settings['hazards'] = val;
        }
        if( refresh ){
            this.refresh();
        }
    }

    setOpacity( val ){
        this.settings['opacity'] = Number(val);
        return 1;
    }

    updateLevel(){
        this.refresh();
    }
    
    updateTime(){
        this.refresh();
    }
}